import React, { Component } from "react";
import { Col, Row, Container, Card, CardHeader, Table } from "reactstrap";

import RequestManager from "../../singletons/RequestManager";

import LoadingOverlay from "react-loading-overlay";
export default class Payments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      storeInformation: null,
      spinnerLoading: false,
      orders: null,
    };
  }

  componentWillMount() {
    this.checkLoginMode();
  }
  componentDidMount() {}

  checkLoginMode = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "merchant") {
      this.setState({
        storeInformation: storeInformation,
        pageText: "Your Order Summary",
      });
    } else {
      this.setState({ storeInformation: storeInformation });
    }
  };

  getOrders = async () => {
    this.setState({ spinnerLoading: true });
    let requestManager = new RequestManager();
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    let loginMode = localStorage.getItem("loginMode");
    let params = {};
    if (loginMode === "store") {
      params = {
        storeId: storeInformation.store.id,
      };
    } else if (loginMode === "merchant") {
      params = {
        merchantId: storeInformation.merchant.id,
      };
    }

    console.log("params", params);
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getOrderHistory",
      params
    );

    if (response.error === null) {
      this.setState({
        spinnerLoading: false,
        orders: response.data.orderHistory.edges,
      });
    } else {
      this.setState({ spinnerLoading: false });
    }

    console.log(response);
  };

  render() {
    const { spinnerLoading } = this.state;
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container fluid style={{ padding: 0, margin: 0 }}>
          <Row noGutters>
            <Col>
              <Card>
                <CardHeader>
                  <Container fluid>
                    <Row>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <h5>{"Payments"}</h5>
                      </Col>
                    </Row>
                  </Container>
                </CardHeader>
                <Table responsive>
                  <tbody>
                    <tr>
                      <th>Order Id</th>
                      <th>Token</th>
                      <th>status</th>
                      <th>Date/Time</th>
                      <th>Amount</th>
                      <th>Store</th>
                    </tr>
                    {this.state.orders &&
                      this.state.orders.map((order) => {
                        return (
                          <tr key={order.node.id} onClick={() => {}}>
                            <td>{order.node.orderId}</td>
                            <td>{order.node.storeToken}</td>
                          </tr>
                        );
                      })}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
      </LoadingOverlay>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Payments/Payments.js